import styled, { css } from 'styled-components/macro';
import { Link } from 'react-router-dom';
import * as colors from '../../common/colorConstants';
import * as breakpoints from '../../common/mediaQueries';
import { Field, Form } from 'formik';

export const Container = styled.div`
  background-color: ${colors.white};
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  z-index: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: ${breakpoints.minTablet}) {
    background-color: ${colors.activeInputGray};
  }
`;

export const LoginBox = styled.div`
  background-color: white;
  width: 100%;
  margin: 223px auto auto;
  @media screen and (max-width: ${breakpoints.minLaptop}) {
    margin: 180px auto auto;
  }
  @media screen and (max-width: ${breakpoints.minTablet}) {
    background-color: ${colors.activeInputGray};
    margin: 52px auto auto;
  }
  @media screen and (max-width: ${breakpoints.maxMobile}) {
    margin: 52px 0 0 0;
  }
`;

export const Title = styled.div`
  margin: 0 0 11px;
  padding: 0;
  color: ${colors.gulfBlue};
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 23px;
  text-align: left;
`;

export const SubTitle = styled.div`
  padding: 0 30px;
  font-family: 'Lato';
  margin: 0 0 50px;
  text-align: center;
  font-size: 14px;
  color: ${colors.black1};
`;

export const ErrorMessage = styled.div`
  text-align: left;
  color: ${colors.red};
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  margin: 4px 0 0 0;
  background-image: url('/images/error-esclamation.svg');
  background-repeat: no-repeat;
  background-position: center left;
  padding-left: 14px;
  background-size: 10px;
`;

export const LoginForm = styled(Form)`
  text-align: center;
`;

export const ResetLink = styled(Link)`
  font-size: 11px;
  color: ${colors.electricBlue};
  text-decoration: none;
`;

export const ResetLinkExternal = styled.a`
  font-size: 11px;
  color: ${colors.electricBlue};
  text-decoration: none;
`;

export const ResetLinkContainer = styled.div`
  margin-top: 12px;

  @media screen and (max-width: ${breakpoints.minLaptop}) {
    margin-top: 16px;
  }

  @media screen and (max-width: ${breakpoints.minTablet}) {
    margin-top: 20px;
  }
`;

export const ActionButtonsWrapper = styled.div`
  padding-top: 19px;
  display: flex;
  width: 100%;
  max-width: 400px;
  gap: 8px;

  @media screen and (max-width: ${breakpoints.maxTablet}) {
    flex-direction: column;
    gap: 12px;
  }

  @media screen and (min-width: ${breakpoints.maxTablet}) {
    flex-direction: row;
  }

  @media screen and (max-width: ${breakpoints.minTablet}) {
    padding-top: 20px;
  }

  @media screen and (max-width: ${breakpoints.minLaptop}) {
    padding-top: 27px;
  }
`;

export const Submit = styled.button`
  flex-grow: 3;
  border: none;
  border-radius: 3px;
  height: 30px;
  background: ${colors.blue2};
  color: ${colors.white};
  font-family: Roboto, sans-serif;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  line-height: 16px;

  @media screen and (max-width: ${breakpoints.maxTablet}) {
    height: 40px;
    order: 1;
  }

  &:disabled {
    background: ${colors.disabledBlue};
    cursor: default;
  }
`;

export const smallTextStyles = css`
  color: ${colors.lightGray20};
  font-family: Roboto, sans-serif;
  font-size: 10px;
  line-height: 16px;
`;

export const SmallText = styled.p`
  margin: 0;
  padding: 0;
  ${smallTextStyles};
`;

export const ContentWrapper = styled.div`
  position: relative;
  padding: 0 56px;
  text-align: left;
  max-width: 412px;
  margin: 0 auto;

  @media screen and (max-width: ${breakpoints.minLaptop}) {
    max-width: 369px;
  }

  @media screen and (max-width: ${breakpoints.minTablet}) {
    padding: 0 24px;
  }
`;

export const textStyles = css`
  color: ${colors.darkGray14};
  font-family: Roboto, sans-serif;
  font-size: 11px;
  line-height: 16px;
  margin-top: 16px;

  @media screen and (max-width: ${breakpoints.minLaptop}) {
    margin-top: 18px;
  }

  @media screen and (max-width: ${breakpoints.minTablet}) {
    margin-top: 24px;
  }

  @media screen and (max-width: ${breakpoints.maxTablet}) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const FooterContentBox = styled.div`
  color: ${colors.slateGray};
  padding: 25px 56px;
  font-size: 11px;
  width: 100%;

  @media screen and (max-width: ${breakpoints.minTablet}) {
    background-color: ${colors.activeInputGray};
  }
`;

export const ExpertFooterContentBox = styled.div`
  color: ${colors.slateGray};
  padding: 25px 56px;
  font-size: 16px;
  width: 100%;

  @media screen and (max-width: ${breakpoints.minTablet}) {
    background-color: ${colors.activeInputGray};
  }
`;

export const BackLinkWrapper = styled.div`
  flex-grow: 1;

  @media screen and (max-width: ${breakpoints.maxTablet}) {
    order: 2;
  }
`;

export const Input = css`
  padding: 11px 16px;
  border: 1px solid ${colors.lightGray21};
  border-radius: 3px;
  width: 100%;
  ${textStyles};
  color: ${colors.lightBlack};
  background-color: ${colors.white};
  outline: none;

  &.error {
    border: 1px solid ${colors.red3};
    background-color: ${colors.intentValidation.red2};
  }

  &::placeholder {
    ${textStyles};
  }

  &:focus {
    border: 1px solid ${colors.blue1};
    background-color: ${colors.activeInputGray};
  }

  &:disabled {
    color: ${colors.lightGray5};
    background-color: ${colors.lightGray14};
    font-weight: bold;
  }
`;

export const TextInput = styled(Field)`
  ${Input};
`;
